export default __webpack_public_path__ + "static/media/react.588cb44b.png";